import store from '@/store'
// 动态导入elvish以处理模块解析错误
let elvishModule = null

async function loadElvish() {
  try {
    elvishModule = await import('@didi/elvish-lib-javascript')
    return elvishModule
  } catch (error) {
    console.warn('无法加载 elvish-lib-javascript:', error)
    return null
  }
}

const defaultConfig = {
  lang: 'es-MX',
  countryCode: 'MX',
  cityId: '52140500',
}

export async function getElvish() {
  const { state = {} } = store
  const { globalParams = {} } = state
  const { lang = '', countryCode = '', cityId = '' } = globalParams

  try {
    const elvish = await loadElvish()
    if (elvish && elvish.init && elvish.setCity) {
      await elvish.init(lang || defaultConfig.lang, countryCode || defaultConfig.countryCode)
      await elvish.setCity(cityId || defaultConfig.cityId)
      console.log('Elvish 初始化成功')
    } else {
      console.warn('Elvish 模块加载失败，使用默认配置')
    }
  } catch (e) {
    console.error('Elvish 初始化错误:', e)
    // 应用可以继续运行，只是没有elvish功能
  }
}
